<template>
    <div>
        <!-- <van-nav-bar title="网格巡检记录" /> -->
        <!-- <van-dropdown-menu>
            <van-dropdown-item v-model="types.val" :options="types.lis" @change="changeType" />
            <van-dropdown-item v-model="sort" :options="option" @change="changeSort" />
        </van-dropdown-menu> -->
        <van-empty description="暂无数据" v-if="grid.ls.length == 0" />
        <div v-else>
            <van-list :finished="grid.finish" @load="loadPage" v-model="grid.loading" :immediate-check="false"
                style="padding: 10px 0px">
                <div class="wcard" v-for="item in grid.ls" :key="item.ID">
                    <div class="bd">
                        <van-row :gutter="8">
                            <van-col :span="24">
                                <p style="display: flex;">
                                    学校：{{ item.SCHOOL_NAME }}
                                    <span class="sta_sty" :class="'sta' + item.STATUS">{{ item.STATUS_TEXT }}</span>
                                </p>
                                <div style="font-size: 14px; color: #696868">
                                    <p>位置：{{ item.LOCATION }}</p>
                                    <p v-if="item.LOCATION_ZH">地址：{{ item.LOCATION_ZH }}</p>
                                    <p>用户：{{ item.CREATED_NAME }}</p>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="ft">
                        <van-row>
                            <van-col :span="12">日期：{{ item.SCAN_DATE }} {{ item.SCAN_TIME }} {{ item.WEEK }}</van-col>
                        </van-row>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>
<script>
export default {
    name: "index",
    data() {
        return {
            grid: {
                sea: {
                    PAGE_SIZE: 10,
                    PAGE_INDEX: -1,
                },
                ls: [],
                total: 0,
                loading: false,
                finish: false,
            },
            user: this.whale.user.get(),

            // show: true,
            // sort: 0,
            // option: [
            //     { text: '默认排序', value: 0 },
            //     { text: '检查日期倒序', value: 1 },
            //     { text: '检查日期正序', value: 2 },
            //     { text: '整改日期倒序', value: 3 },
            //     { text: '整改日期正序', value: 4 },

            // ],
        };
    },
    mounted() {
        // console.log(this.user)
    },
    created() {
        this.filter();

    },
    methods: {
        filter() {
            this.grid.sea.PAGE_INDEX = 0;
            this.grid.ls = [];
            this.grid.finish = false;
            this.getList();
        },
        loadPage() {
            this.grid.sea.PAGE_INDEX += 1;
            this.getList();
        },
        // typesSel(e) {
        //     this.types.val = e.NAME
        //     this.grid.sea.TYPE_ID = e.KEY
        //     this.types.show = false
        //     this.filter();
        // },
        getList() {
            let self = this;
            this.grid.loading = true;
            this.whale.remote.getCollection({
                url: "/api/Mobile/INS/ScanCodeApi/GetList",
                data: this.grid.sea,
                finally() {
                    self.grid.loading = false;
                },
                completed: function (its, n) {
                    self.grid.ls.push(...its.ITEMS);
                    if (self.grid.ls.length >= n) self.grid.finish = true;
                },
            });
        },
        // changeType() {
        //     this.grid.sea.TYPE_ID = this.types.val
        //     console.log(this.grid.sea)
        //     this.filter();
        // },
        // changeSort() {
        //     this.grid.sea.SORT = this.sort
        //     console.log(this.grid.sea)
        //     this.filter();
        // }
    },
};
</script>

<style scoped>
.wcard {
    margin: 0 12px 12px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}

.wcard .ft {
    border-top: 1px dashed #ebedf0;
    padding: 8px 16px;
    font-size: 12px;
    min-height: 20px;
}

.wcard .ft .ov {
    color: #ee0a24;
    font-weight: bold;
}

.wcard .bd {
    padding: 0px 15px;
}

.wcard .bd .lf {
    text-align: center;
    color: #ee0a24;
    padding-top: 10px;
}

.wcard .bd .lf h2 {
    font-size: 30px;
    font-weight: 500;
    display: inline;
}

.wcard .bd .lf span {
    font-size: 40%;
    font-weight: normal;
    margin-left: 2px;
}

.wcard .bd .lf p {
    font-size: 14px;
    line-height: 16px;
}

.sta_sty {
    margin-left: auto;
    /* color: #3880ec; */
    font-size: 16px;
}

.sta0 {
    color: #a8aaac;
}

.sta1 {
    color: #f06e6e;
}

.sta2 {
    color: #668fe9;
}
</style>